import { createContext, useContext, useEffect, useState } from "react";
import { adminAxios } from "../config/adminAxios";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checking, setChecking] = useState(true);

  // On mount, ask the server if our cookie grants admin access.
  useEffect(() => {
    let active = true;
    adminAxios.get("/admin/me")
      .then(res => { if (active) setIsAdmin(Boolean(res.data?.authenticated)); })
      .catch(() => { if (active) setIsAdmin(false); })
      .finally(() => { if (active) setChecking(false); });
    return () => { active = false; };
  }, []);

  const login = async (username, password) => {
    const res = await adminAxios.post("/admin/login", { username, password });
    if (res.data?.success) {
      setIsAdmin(true);
      return true;
    }
    return false;
  };

  const logout = async () => {
    try {
      await adminAxios.post("/admin/logout", {});
    } catch {
      // Even if the server call fails, clear local state.
    }
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ isAdmin, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
